import SliderPress from './press/script';
import SliderTeam from './team/script';
import SliderViewAll from './view-all/script';

export default {
	[SliderPress.selector]: SliderPress,
	[SliderTeam.selector]: SliderTeam,
	[SliderViewAll.selector]: SliderViewAll
};
